import type { LucideIcon } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export interface StatsCardItem {
  key: string;
  title: string;
  value: string;
  description?: string;
  icon?: LucideIcon;
}

export function StatsCards({ items }: { items: StatsCardItem[] }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-2">
      {items.map((item) => (
        <Card
          key={item.key}
          className="border-muted/60 bg-gradient-to-br from-white via-white to-orange-50 dark:from-neutral-900 dark:via-neutral-900 dark:to-neutral-950"
        >
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-muted-foreground text-sm font-medium">{item.title}</CardTitle>
            {item.icon && <item.icon className="size-5 text-orange-500" aria-hidden="true" />}
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">{item.value}</p>
            {item.description ? <p className="text-muted-foreground mt-2 text-sm">{item.description}</p> : null}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
